<template>
    <div id="video-modal-wrapper">
        <div class="modal fade video-modal" id="video-modal" tabindex="-1" role="dialog">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <div class="modal-title h4">Video</div>
                        <button type="button" class="close" data-dismiss="modal" @click="closeVideo">&times;</button>
                    </div>
                    <div class="modal-body">
                        <div class="video-container" v-if="showyoutube">
                            <iframe
                                    width="560"
                                    height="315"
                                    :src="'https://www.youtube-nocookie.com/embed/'+yt"
                                    title="Video"
                                    frameborder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowfullscreen>
                            </iframe>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default
    {
        props:["yt"],
        data: function()
        {
            return {
                showvideo:false,
            }
        },
        created:function()
        {
            vueEventHub.$on("showvideo", video =>
            {
                this.showvideo = true
            });
        },
        methods:
            {
                closeVideo()
                {
                    this.showvideo = false;
                }
            },
        computed:
            {

                showyoutube:function()
                {
                    return this.showvideo;
                }
            }
    }
</script>
